import { first } from 'rxjs/operators';
import { GuestMasterProfileService, GuestMasterProfile } from '@app/_components/guest-master-profile';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA ,MatDialogModule} from '@angular/material/dialog';
import { GuestMasterProfileComponent } from '../guest-master-profile/guest-master-profile.component';
import { Component, EventEmitter, Input, OnInit, Output ,Inject } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-guest-master-profile-list',
    templateUrl: './guest-master-profile-list.component.html',
    styleUrls: ['./guest-master-profile-list.component.css'],
    providers: [MessageService, ConfirmationService],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
}) 
export class GuestMasterProfileListComponent implements OnInit {
	public dialogData: any;
	questId=0;
	constructor(
		private guestMasterProfileService: GuestMasterProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) private data:any
		
	) {
		this.statuses = guestMasterProfileService.statuses;
		this.dialogData = data;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Output() doUpdate = new EventEmitter<any>();
	guestMasterProfiles: any;
	guestMasterProfile: GuestMasterProfile;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;


	statuses: any;

	columns: any[] = [
		{ field: 'guestMasterProfileId', header: 'Id', width: 'auto' },
		{ field: 'firstName', header: 'First Name', width: 'auto' },
		{ field: 'lastName', header: 'Last Name', width: 'auto' },
		{ field: 'emailAddress', header: 'Email', width: 'auto' },
		{ field: 'mobilePhone', header: 'Mobile', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			this.questId=0;
			if (this.dialogData.guestId!=undefined){
				this.questId=this.dialogData.guestId;
				this.getProfileData(this.dialogData.guestId);
			}
			//if (this.dialog.data)
			// default sort of list
			else{
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
			}
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.guestMasterProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-guestMasterProfile-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.guestMasterProfileService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.guestMasterProfiles = res.data.guestMasterProfiles;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.guestMasterProfiles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.doUpdate.emit(event.data);
		// this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(guestMasterProfile: GuestMasterProfile) {
		try {
			this.formLoading = true;
			this.guestMasterProfileService.update(guestMasterProfile)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.guestMasterProfiles.map((guestMasterProfile, i) => {
							if (guestMasterProfile.guestMasterProfileId === res.data.guestMasterProfile.guestMasterProfileId) {
								this.guestMasterProfiles[i] = res.data.guestMasterProfile;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(guestMasterProfile: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(guestMasterProfile));

			this.formLoading = true;
			this.guestMasterProfileService.delete(guestMasterProfile.guestMasterProfileId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.guestMasterProfiles.splice(this.guestMasterProfiles.indexOf(guestMasterProfile), 1);
						this.recordTotal = this.guestMasterProfiles.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'GuestMasterProfile ' + guestMasterProfile.guestMasterProfileId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'GuestMasterProfile ' + guestMasterProfile.guestMasterProfileId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add GuestMasterProfile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestMasterProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addGuestMasterProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});
		
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(guestMasterProfile: any) {
        
		const dialogConfig = new MatDialogConfig();
       // settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = false;
		//dialogConfig.panelClass = "edit-custom-modalbox";
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			guestMasterProfile: guestMasterProfile,
			title: 'Edit Guest Master Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestMasterProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateGuestMasterProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteGuestMasterProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});

			// to receive the added element, subscribe to the eventEmitter we created 'doUpdatePreSelected' in the element to handle adding
			//need to send Data to Quote Screen in Edit
		dialogRef.componentInstance.doUpdatePreSelected.subscribe(
			data => {
				console.log('Dialog output: ', data);
				this.updateGuestMasterProfileCBQuote(data);
				
				dialogRef.close({"data":data});
			});	
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addGuestMasterProfileCB(guestMasterProfile: GuestMasterProfile) {
		console.log('Adding GuestMasterProfile: ' + JSON.stringify(guestMasterProfile));
		// if we don't have a guestMasterProfiles array yet...
		if (!this.guestMasterProfiles) {
			this.guestMasterProfiles = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.guestMasterProfiles.unshift(guestMasterProfile);

		// no idea what this is but it is required to update the array
		this.guestMasterProfiles = [...this.guestMasterProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestMasterProfile ' + guestMasterProfile.guestMasterProfileId + ' Added', life: 3000 });
	}

	updateGuestMasterProfileCB(guestMasterProfile: GuestMasterProfile) {
		console.log('Updating GuestMasterProfile: ' + JSON.stringify(guestMasterProfile));
		let itemIndex = this.guestMasterProfiles.findIndex((item: any) => item.guestMasterProfileId === guestMasterProfile.guestMasterProfileId);
		this.guestMasterProfiles[itemIndex] = guestMasterProfile;

		// no idea what this is but it is required to update the array
		this.guestMasterProfiles = [...this.guestMasterProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestMasterProfile ' + guestMasterProfile.guestMasterProfileId + ' Updated', life: 3000 });
	}

	deleteGuestMasterProfileCB(guestMasterProfile: GuestMasterProfile) {
		console.log('Removing GuestMasterProfile: ' + guestMasterProfile);
		this.guestMasterProfiles.splice(this.guestMasterProfiles.indexOf(guestMasterProfile), 1);
		this.recordTotal = this.guestMasterProfiles.length;

		// no idea what this is but it is required to update the array
		this.guestMasterProfiles = [...this.guestMasterProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestMasterProfile ' + guestMasterProfile.guestMasterProfileId + ' Deleted', life: 3000 });
	}

	updateGuestMasterProfileCBQuote(guestMasterProfile: GuestMasterProfile) {
		this.doUpdate.emit(guestMasterProfile);
		
	}

	

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.guestMasterProfiles ? this.first === (this.guestMasterProfiles.length - this.rows) : true; }
	isFirstPage(): boolean { return this.guestMasterProfiles ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	getProfileData(guestId :any){
		
		this.guestMasterProfileService.findById(guestId)
				.subscribe(
					(res: any) => {
						console.log(res.data);
						this.onOpenFormEdit(res.data.guestMasterProfile);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
	}
}
